import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, AccountingSystemDialogueHandler } from './types';
import AccountingSystemContext from './AccountingSystemContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type AccountingSystemDialogueProps = {
  handleDialogue: DialogueHandler<AccountingSystemDialogueHandler>;
};

type FC = FunctionComponent<AccountingSystemDialogueProps>;

const AccountingSystemDialogue: FC = ({ handleDialogue }: AccountingSystemDialogueProps) => {
  const { showSyncStarted, showError, errorMessage } = useContext(AccountingSystemContext);
  const { t } = useTranslation('translations', { keyPrefix: 'AccountingSystem.Dialogs' });

  return useMemo(
    () => (
      <div>
        {/* Sending Error Confirmation */}
        <ConfirmationDialogue
          isVisible={showError}
          title={t('SendingErrorConfirmation.title')}
          status="error"
          subTitle={`${errorMessage}`}
          confirm={{
            label: t('SendingErrorConfirmation.confirmButton'),
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />

        {/* Cancel Bulk Confirmation */}
        <ConfirmationDialogue
          isVisible={showSyncStarted}
          title={t('CancelBulkConfirmation.title')}
          status="success"
          subTitle={t('CancelBulkConfirmation.subTitle')}
          confirm={{
            label: t('CancelBulkConfirmation.confirmButton'),
            action: () => handleDialogue({ type: 'sync', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showError, errorMessage, showSyncStarted],
  );
};

export default AccountingSystemDialogue;
